import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout'

const Redirect = resolve => require.ensure([], () => resolve(require('../views/Redirect')), 'Redirect')
const Login = resolve => require.ensure([], () => resolve(require('../views/Login')), 'Login')
const Stores = resolve => require.ensure([], () => resolve(require('../views/Stores')), 'Stores')
const Index = resolve => require.ensure([], () => resolve(require('../views/Home/index')), 'Home')
const BannerDetail = resolve => require.ensure([], () => resolve(require('../views/BannerDetail')), 'BannerDetail')
const CkContent = resolve => require.ensure([], () => resolve(require('../views/CkContent')), 'CkContent')
const Setting = resolve => require.ensure([], () => resolve(require('../views/Setting')), 'Setting')
// const Download = resolve => require.ensure([], () => resolve(require('../views/Download')), 'Download')
const Error404 = resolve => require.ensure([], () => resolve(require('../views/Error404')), 'Error404')

Vue.use(VueRouter)

const routes = [
  {
    path: '/redirect',
    component: Layout,
    children: [
      {
        path: '/redirect/:path*',
        component: Redirect
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      name: '登录',
      keepAlive: false
    }
  },
  {
    path: '/ckContent',
    name: 'CkContent',
    component: CkContent,
    meta: {
      name: 'CkContent',
      keepAlive: false
    }
  },
  {
    path: '/404',
    name: '404',
    component: Error404,
    meta: {
      name: '404',
      keepAlive: true
    }
  },
  // {
  //   path: '/app-nt-download',
  //   name: 'App-nt-download',
  //   component: Download,
  //   meta: {
  //     name: '下载',
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: '/app-tp-download',
  //   name: 'App-tp-download',
  //   component: Download,
  //   meta: {
  //     name: '下载',
  //     keepAlive: false
  //   }
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/stores',
        name: 'Stores',
        component: Stores,
        meta: {
          name: '门店列表',
          keepAlive: true
        }
      },
      {
        path: '/index',
        name: 'Index',
        component: Index,
        meta: {
          name: 'Index',
          keepAlive: false
        }
      },
      {
        path: '/bannerDetail',
        name: 'BannerDetail',
        component: BannerDetail,
        meta: {
          name: 'BannerDetail',
          keepAlive: false
        }
      },
      {
        path: '/setting',
        name: 'Setting',
        component: Setting,
        meta: {
          name: 'Setting',
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  }

]

const router = new VueRouter({
  routes
})

export default router
